import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, ReplaySubject, Subject } from "rxjs";
import { Filter, PaginationPage, PaginationResponse } from "src/app/classes";
import { DoubletSuggestion } from "src/app/lib/shared/classes";
import { IDoubletProviderService } from "src/app/lib/shared/interfaces";
import { Address } from "../../../classes";
import { LocationService } from "../../../services/location.service";

@Injectable()
export class AddressFormComponentService implements IDoubletProviderService {

    private _checkerVisible = new BehaviorSubject(false);
    checkerVisible$: Observable<boolean> = this._checkerVisible.asObservable();

    private _doubletClicked = new Subject<DoubletSuggestion>();
    doubletClicked$: Observable<DoubletSuggestion> = this._doubletClicked.asObservable();

    private _doublets = new ReplaySubject<PaginationResponse<DoubletSuggestion[]>>(1);
    doublets$: Observable<PaginationResponse<DoubletSuggestion[]>> = this._doublets.asObservable();

    constructor(private _locationService: LocationService) { }

    doubletClick(doublet: DoubletSuggestion) {
        this._doubletClicked.next(doublet);
    }

    setDoubletCheckerVisible = (value: boolean) => this._checkerVisible.next(value);

    setSearchFilter(filter: Filter, page: PaginationPage){
        this._locationService.searchAddresses(filter, page).subscribe((result: PaginationResponse<Address[]>) => this._doublets.next({
            'page': result.page,
            'content': result.content.map(x => {
                return {
                    'identifier': x.addressid, 
                    'title': [x.addressstreet, x.addresshousenumber].filter(x => x? true: false).join(' '), 
                    'subTitles': [{ 'attribute': null, 'value': [x.addresszipcode, x.addresscity].filter(x => x? true: false).join(' ') }] 
                }
            }),
            'totalItems': result.totalItems
        }));
    }

    setSearchString(searchString: string){
        throw new Error("not implemented");
    }

}